<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <div>
    <span style="display: block; background-color: #DDDDDD; padding: 10px; line-height: 30px; height: 30px;">選項內容編輯</span>
    <f7-list
      v-if="options"
      sortable
      :sortable-enabled="true"
      @sortable:sort="onOptionSort($event.detail.from, $event.detail.to)"
      no-hairlines-between
      style="margin: 0px 0px 0px 0px;">
      <f7-list-item v-for="(option, index) in options" :key="`menu-drafts-options-edit-${index}`" @click="showOptionActions(option.id, index)">
        <span slot="title">{{ index + 1 }}. {{ option.title }}: ${{ parseFloat(option.price) }}</span>
        <font-awesome-icon slot="after" icon="edit" style="color: #4CAF50; margin-right: 10px;" />
      </f7-list-item>
    </f7-list>

    <f7-button fill raised style="margin: 10px 10%;" @click="createOption({ questionId, title: '新選項內容', price: 0, elementLevel })">新增選項內容</f7-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  dependencies: ['questionType'],
  data () {
    return {
      pathLength: 0
    }
  },
  created () {
    this.pathLength = this.currentElementPath.length
  },
  computed: {
    ...mapState('menuDraftModule', ['currentDraft', 'currentElementPath']),
    elementLevel () { return this.pathLength === 6 ? 5 : 3 },
    currentQuestion () { return this.currentDraft.questions[this.questionId] },
    options () { return this.currentQuestion.options.map(k => this.currentDraft.options[k]) }
  },
  props: {
    storeId: String,
    menuDraftVariation: String,
    questionId: String
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'createOption', 'setQuestionProperties']),
    onOptionSort (from, to) {
      const options = this.currentQuestion.options.slice()
      options.splice(to, 0, options.splice(from, 1)[0])
      this.setQuestionProperties({ questionId: this.questionId, elementLevel: this.elementLevel, properties: { options } })
    },
    showOptionActions (optionId, index) {
      this.setCurrentElementPath(this.currentElementPath.slice(0, this.pathLength).concat({ id: optionId, index }))
      this.$f7router.navigate(`/stores/${this.storeId}/menu-drafts/${this.menuDraftVariation}/options/${optionId}/option-actions`)
    }
  }
}
</script>
